import axios from "axios";
import { DailyRecord, User } from "./sudoku.types";

const httpClient = axios.create({
  baseURL: "https://k0lz9gdd94.execute-api.us-east-1.amazonaws.com/prod"
});

const getRecords = async (filters: object) => {
  try {
    const res = await httpClient.get("/daily-records", { params: filters });
    return res.data;
  } catch (error) {
    // console.log(`Get Records Error: ${error.message}`);
    throw new Error("Error getting records");
  }
};

const createRecord = async (item: DailyRecord) => {
  try {
    const result = await httpClient.post("/daily-records", item);

    return result.data;
  } catch (error) {
    // console.log(`Create Item Error: ${error.message}`);
    throw new Error("Can't create record");
  }
};

const updateRecord = async (item: DailyRecord) => {
  try {
    const result = await httpClient.put(`/daily-records/${item.id}`, item);

    return result.data;
  } catch (error) {
    // console.log(`Update Item Error: ${error.message}`);
    throw new Error("Can't update record");
  }
};

const deleteRecord = async (item: DailyRecord) => {
  try {
    const result = await httpClient.delete(
      `/daily-records/${item.sudoku_id}__${item.user_id}`
    );

    return result.data;
  } catch (error) {
    // console.log(`Delete Item Error: ${error.message}`);
    throw new Error("Can't delete Record");
  }
};

const getUsers = async (filters: object): Promise<User[]> => {
  try {
    return await httpClient
      .get(`/users`, { params: { ...filters } })
      .then(res => res.data);
  } catch (error) {
    // console.log(`Get Users Error: ${error.message}`);
    throw new Error("Error getting users");
  }
};

const createUser = async (u: User): Promise<User> => {
  try {
    return await httpClient.post("/users", u).then(res => res.data);
  } catch (error) {
    // console.log(`Create User Error: ${error.message}`);
    throw new Error("Error creating users");
  }
};

const updateUser = async ({ id, ...rest }: User): Promise<User> => {
  try {
    return await httpClient.put(`/users/${id}`, rest).then(res => res.data);
  } catch (error) {
    // console.log(`Update User Error: ${error.message}`);
    throw new Error("Error updating user");
  }
};
const deleteUser = async ({ id }: User): Promise<string> => {
  try {
    return await httpClient.delete(`/users/${id}`).then(res => res.data);
  } catch (error) {
    // console.log(`Delete User Error: ${error.message}`);
    throw new Error("Error deleting user");
  }
};

export default {
  getRecords,
  createRecord,
  updateRecord,
  deleteRecord,
  getUsers,
  createUser,
  updateUser,
  deleteUser
};
